import { Body1Strong } from '@fluentui/react-components';
import classNames from 'classnames';

import { LibraryIcon } from '@shared/icons';

import { BLOCK_HEADER_ATTR } from './constants';

type TProps = {
  name: string;
  /** Link to the snippet. Always opens in a new tab, so a plain anchor is enough. */
  href: string;
  isQm: boolean;
  isError: boolean;
};

/**
 * The row above a reusable block: the library icon that marks it as reused, and the snippet's name.
 *
 * One component, two renderings - the node view mounts it, and the static half renders it to a string
 * (`largeDocument/blockHeader.ts`). A block sits on both sides of a part boundary, so the same 40px row
 * has to appear in both or the page moves when it crosses. Keeping it as one component is what makes
 * that true by construction instead of by two drawings being kept in step.
 */
export const BlockHeader = ({ name, href, isQm, isError }: TProps) => (
  <div
    {...{ [BLOCK_HEADER_ATTR]: '' }}
    className={classNames('flex items-center h-10', isError ? 'text-red-500' : 'text-brand-80')}
  >
    <LibraryIcon variant={isQm ? 'qm' : 'default'} filled={false} fontSize="24px" />
    <a href={href} target="_blank" rel="noreferrer" className="block-info ml-1 unstyled">
      <Body1Strong className="hover:underline">{name}</Body1Strong>
    </a>
  </div>
);
